<template>
    <div>
        <alan-zwdd :isShowZwdd='true'></alan-zwdd>

        <alan-login :isshowLogin='isshowLogin'></alan-login>
    </div>
</template>
<script>
// import store from '../store'
export default {
    data () {
        return {
            isshowLogin:true,
            isshowRegist:false,
            sharedState: this.$store.state
        }
    },
    methods:{
        change(){
            this.$store.setMessageAction(0)
        },
        aaa(){
            console.log(123);
        }
    },
    created(){
        // console.log(store.state.loginState);
        // store.commit('login_succ')
        // console.log(store.state.loginState);
        // store.commit('exit_succ')
        // console.log(store.state.loginState);
    }
}
</script>

<style>

</style>
